import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { title } from 'modules/reviews/components/Analytics/utilities'

interface Props {
  formName: string
  keyName: string
}

const TableOptions = ({ formName, keyName }: Props) => {
  return (
    <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
      <Text.Normal weight="medium">{title(formName, keyName)}</Text.Normal>
    </Box>
  )
}

export default TableOptions
